const isImageValid = (values, attributeName, imageName) => {
  return (
    values[attributeName] &&
    values[attributeName][imageName] &&
    Object.keys(values[attributeName][imageName]).length > 0
  );
};

export const validateStyle = (values, {translate}) => {
  const errors = {};

  if (!isImageValid(values, "web_offer_style", "logo")) {
    errors.web_offer_style = errors.web_offer_style || {};
    errors.web_offer_style.logo = 'gggg';
  }

  return errors;

};

export const validateBackgroundColor = (value, allValues, props) => {
  return (
    (!value || value.trim() === "") &&
    props.translate("resources.marketingPartners.validation.requiredBackgroundColor")
  );
};

export const validateTextColor = (value, allValues, props) => {
  return (
    (!value || value.trim() === "") &&
    props.translate("resources.marketingPartners.validation.requiredTextColor")
  );
};


// WEBPACK FOOTER //
// ./src/containers/CRM/MarketingPartners/validations.js